import React, { Component, KeyboardEvent, ChangeEvent, MouseEvent } from "react";
import {
    Row, Col, Button, Modal, ModalBody, ModalHeader, ModalFooter, Spinner, Nav, NavItem, NavLink, TabContent, TabPane
} from "reactstrap";
import * as KSLPlusAPI from "../services/KSLPlusAPI"

import Chart from "react-google-charts";

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
    AccordionItemState
} from 'react-accessible-accordion';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
// @ts-ignores
import BootstrapTable from 'react-bootstrap-table-next';
// @ts-ignore
import cellEditFactory from 'react-bootstrap-table2-editor';
// @ts-ignore
import paginationFactory from 'react-bootstrap-table2-paginator';
// @ts-ignore
import  filterFactory, { selectFilter, multiSelectFilter, textFilter  } from 'react-bootstrap-table2-filter';


import { GRHaushalt } from './GRHaushaltComp';
import { GLHaushalt } from './GLHaushaltComp';
import { GREbenenHaushalt } from './GREbenenHaushaltComp';

import { EbenenHaushalt } from './EbenenHaushaltComp';


import * as Utilities from "./Utilities"

import { env } from '../env';
import '../custom.css';
import { ENGINE_METHOD_PKEY_ASN1_METHS } from "constants";

import * as QueryString from "query-string";

type State = {
    ready: boolean;          
    activeMainTab: string,
    selectedGLEbene: string,
    isVisible: boolean
}

type Props = {    
    kunde: number,
    gemeinde: number,
    jahr: number,
    plantyp: number,
    planstufe: number,
    verwaltungsansicht: boolean,
    uhconfig: KSLPlusAPI.Uhconfig | undefined,
    settings: KSLPlusAPI.SettingsModel,
    selectedGL:string,
    onSelGLChange: (ebeneId: string) => void,
    massnahmen: KSLPlusAPI.Massnahman[],
    isVisible: boolean,
    query: string | undefined,
    onReady: () => void
}


export class VMHaushalt extends Component<Props, State> {
    constructor(props: any) {
        super(props);



    }

    static defaultProps = {
        onReady: () => { }
    }

    node: any;
    hhGL: KSLPlusAPI.HaushaltsEbene | null = null;
    //hhGL_Ausgaben: KSLPlusAPI.HaushaltsEbene | null;
    hhGR: KSLPlusAPI.HaushaltsEbene | null = null;    
    hhGR4E: KSLPlusAPI.HaushaltsEbene | null = null; 
    //hhGR_Ausgaben: KSLPlusAPI.HaushaltsEbene | null;
    //hhEbenen_Einnahmen: KSLPlusAPI.HaushaltsEbene[];
    hhEbenen: KSLPlusAPI.HaushaltsEbene[] = [];
    defTab: string = "";
    

    state: State = {
        ready: true,        
        activeMainTab: "",
        selectedGLEbene: "",
        isVisible: false
    }

    
    

    readHHGLData = () => {
        var request = new KSLPlusAPI.HaushaltRequest();
        var kunde = 0;
        if (this.props.kunde === undefined)
            return;
        request.kunde = this.props.kunde;
        var gemeinde = 0;
        if (this.props.gemeinde === undefined)
            return;
        request.gemeinde = this.props.gemeinde;
        var jahr = 0;
        if (this.props.jahr === undefined)
            return;
        request.jahr = this.props.jahr;

        request.plantyp = this.props.plantyp;
        request.planstufe = this.props.planstufe;
        request.uhConfig = this.props.uhconfig ? this.props.uhconfig.id : 0;   
        request.verwaltungsAnsicht = this.props.verwaltungsansicht;
        request.haushaltsart = 2; // VMHH
        
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";
       
        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        request.gruppen = [3,9];
        request.ignorierteGruppen = [0,1,2,4,5,6,7,8];
        //request.ignorierteGruppen = [800, 801, 802, 803, 804, 805, 806, 807, 808, 86, 201, 202, 203, 204, 205, 206, 207, 208, 28, 3, 9];
        if (this.props.settings.hiddenTabs?.findIndex(ht => ht.typ === 2) === -1) {
            client.getHaushaltByGliederung("", request).then((hh) => {                
                hh.selected = true;
                this.hhGL = hh;
                this.state.activeMainTab = "1";
                this.defTab = "1";  
                this.readHHGRData();
                this.setState({ ready: true });
                this.props.onReady();
            }).catch(Reason => {
                this.readHHGRData();
            });
        }
        else
            this.readHHGRData();
        /*        
        request.gruppen = [0,1,2];
        client.getHaushaltByGliederung( "", request ).then((hh) => {
            this.hhGL_Einnahmen = hh;                          
            this.setState({ ready: true });
        }).catch(Reason => {
            alert("failed");
        });

        request.gruppen = [4, 5, 6, 7, 8];
        client.getHaushaltByGliederung("", request).then((hh) => {
            this.hhGL_Einnahmen = hh;
            this.readHHGRData();
            this.setState({ ready: true });
        }).catch(Reason => {
            alert("failed");
        });
        */

    }

    

    readHHGRData = () => {
        var request = new KSLPlusAPI.HaushaltRequest();
        var kunde = 0;
        if (this.props.kunde === undefined)
            return;
        request.kunde = this.props.kunde;
        var gemeinde = 0;
        if (this.props.gemeinde === undefined)
            return;
        request.gemeinde = this.props.gemeinde;
        var jahr = 0;
        if (this.props.jahr === undefined)
            return;
        request.jahr = this.props.jahr;

        request.plantyp = this.props.plantyp;
        request.planstufe = this.props.planstufe;
        request.uhConfig = this.props.uhconfig ? this.props.uhconfig.id : 0;   
        request.verwaltungsAnsicht = this.props.verwaltungsansicht;
        request.haushaltsart = 2; // VMHH
        
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";
        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

                
        request.gruppen = [3,9];
        //request.ignorierteGruppen = [3, 9];
        //request.ignorierteGruppen = [800, 801, 802, 803, 804, 805, 806, 807, 808, 86, 91, 201, 202, 203, 204, 205, 206, 207, 208, 28, 31, 3, 9];
        //request.ignorierteGruppen = [800, 801, 802, 803, 804, 805, 806, 807, 808, 86, 91, 201, 202, 203, 204, 205, 206, 207, 208, 28, 31];
        client.getHaushaltByGruppierung("", request).then((hh) => {
            if (this.props.settings.hiddenTabs?.findIndex(ht => ht.typ === 4) === -1) {
                hh.selected = true;
                this.hhGR = hh;
                if (this.props.settings.hiddenTabs?.findIndex(ht => ht.typ === 2) !== -1) {
                    this.state.activeMainTab = "2";
                    this.defTab = "2";
                }
                this.props.onReady();
            }
            this.hhGR4E = hh;
            this.setState({ ready: true });            
        }).catch(Reason => {
        });
        /*
        request.gruppen = [0,1,2];
        //request.ignorierteGruppen = [800, 801, 802, 803, 804, 805, 806, 807, 808, 86, 91, 201, 202, 203, 204, 205, 206, 207, 208, 28, 31];
        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        client.getHaushaltByGliederung("", request).then((hh) => {
            this.hhGR_Einnahmen = hh;            
            this.setState({ ready: true });            
        }).catch(Reason => {
        });

        request.gruppen = [4, 5, 6, 7, 8];
        client.getHaushaltByGliederung("", request).then((hh) => {
            this.hhGR_Ausgaben = hh;
            this.readEbenen();
            this.setState({ ready: true });
        }).catch(Reason => {
        });
        */
    }

    readEbenenData = (ebene: KSLPlusAPI.Ebenen) => {
        var request = new KSLPlusAPI.HaushaltRequest();
        var kunde = 0;
        if (this.props.kunde === undefined)
            return;
        request.kunde = this.props.kunde;
        var gemeinde = 0;
        if (this.props.gemeinde === undefined)
            return;
        request.gemeinde = this.props.gemeinde;
        var jahr = 0;
        if (this.props.jahr === undefined)
            return;
        request.jahr = this.props.jahr;

        request.plantyp = this.props.plantyp;
        request.planstufe = this.props.planstufe;
        request.uhConfig = this.props.uhconfig ? this.props.uhconfig.id : 0;   
        request.ebene = ebene.ebenenId;
        request.verwaltungsAnsicht = this.props.verwaltungsansicht;

        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";
        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        request.gruppen = [0, 1, 2];
        
        var client = new KSLPlusAPI.DigitalHoushold_Client(api);
        
        request.gruppen = [3,9];
        request.ignorierteGruppen = [0,1,2,4,5,6,7,8];
        //request.ignorierteGruppen = [800, 801, 802, 803, 804, 805, 806, 807, 808, 86, 91, 201, 202, 203, 204, 205, 206, 207, 208, 28, 31];
        client.getHaushaltByEbene("", request).then((hh) => {
            hh.ebene = ebene;            
            this.hhEbenen.push(hh);            
            this.setState({ ready: true });
            this.props.onReady();
        }).catch(Reason => {           
        });
    }

    readEbenen = () => {
        this.hhEbenen = [];
        var request = new KSLPlusAPI.JahrModel();
        var kunde = 0;
        if (this.props.kunde === undefined)
            return;
        request.kunde = this.props.kunde;
        var gemeinde = 0;
        if (this.props.gemeinde === undefined)
            return;
        request.gemeinde = this.props.gemeinde;
        var jahr = 0;
        if (this.props.jahr === undefined)
            return;
        request.jahr = this.props.jahr;
        request.verwaltungsansicht = this.props.verwaltungsansicht;

        switch (this.props.plantyp) {
            case 3:
                request.modul = 1;
                break;

            case 4:
                request.modul = 2;
                break;

            default:
                request.modul = 0;
                break;
        }
        

        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";
        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        client.toplevelebenen(this.props.plantyp, this.props.planstufe, true, "", request).then((ebenen) => {
            for (var i = 0; i < ebenen.length; i++) {
                var ebene = ebenen[i];
                if ( ebene.ebenenId )
                    this.readEbenenData(ebene);
            }
            this.setState({ ready: true });
        }).catch(Reason => {
        });
    }
    
    
    readData = () => {
        this.readHHGLData();        
        this.readEbenen();
    }


    componentDidUpdate(prevProps: Props) {
        if (prevProps.isVisible !== this.props.isVisible && this.props.isVisible !== this.state.isVisible && this.defTab !== "") {
            this.setState({ activeMainTab: this.defTab });
            this.parseParams();
        }

        if (prevProps.uhconfig !== this.props.uhconfig && this.props.plantyp === 4)
            this.readData();

        if (prevProps.planstufe !== this.props.planstufe || prevProps.plantyp !== this.props.plantyp)
            this.readData();
        else if (prevProps.isVisible !== this.props.isVisible && this.hhGL) {            
            this.hhGL.selected = true;
        }

    }    

    componentDidMount() {
        this.readData();
        this.parseParams();
    }

    parseParams = () => {
        if (!this.props.query)
            return;

        const params = QueryString.parse(this.props.query);


        if (params.hht != null) {
            if (Array.isArray(params.hht))
                this.setState({ activeMainTab: params.hht[0] });
            else
                this.setState({ activeMainTab: params.hht });
        }
    }


    isEbeneVisible = (ebene: string) => {
        return this.props.isVisible && this.state.activeMainTab === ebene;
    }


    createEbeneItems = (ebenen: KSLPlusAPI.HaushaltsEbene[]) => {
        var navItems: JSX.Element[] = [];
        var contentItems: JSX.Element[] = [];


        if ( !ebenen.length )
            return {navItems: navItems, contentItems: contentItems};

        var tabIdx = 0;
        for (var i = 0; i < ebenen.length; i++) {
            const tabId = (2*i+3).toString();
            var bezeichnung = "Betrachtung nach " + ebenen[i].bezeichnung;
            navItems.push(                
                <NavItem id={"kslplus-tab-" + bezeichnung.toLowerCase().replace(/ /gi, "-") + "-vermögenshaushalt"} key={"mnav" + tabId+toString()}>
                <NavLink active={this.state.activeMainTab === tabId} onClick={() => this.setState({ activeMainTab: tabId })} tabIndex={0} onKeyDown={(e) => { if (e.keyCode === 13) this.setState({ activeMainTab: tabId }); }}>
                        {bezeichnung}
                    </NavLink>
                </NavItem>                      
            );
            
            var tt = Utilities.createTTItem(this.props.settings, bezeichnung.toLowerCase().replace(/ /gi, "-") + "-vermögenshaushalt");            
            if (tt) {
                navItems.push(
                    tt
                );
            }
            contentItems.push(
                <TabPane tabId={tabId} key={"mtab" + tabId+toString()}>                    
                    <div className="kslplus-haushaltstab-wrapper" >
                        <EbenenHaushalt hh={ebenen[i]} kunde={this.props.kunde} gemeinde={this.props.gemeinde} planstufe={this.props.planstufe} plantyp={this.props.plantyp} uhconfig={this.props.uhconfig} jahr={this.props.jahr} settings={this.props.settings} isvmhh={true} massnahmen={this.props.massnahmen} verwaltungsansicht={this.props.verwaltungsansicht} isVisible={this.props.isVisible && this.state.activeMainTab === tabId} />
                    </div>
                    
                </TabPane> 
            );  

            if (this.defTab === "" && this.props.settings.hiddenTabs?.findIndex(ht => ht.typ === 2) !== -1 && this.props.settings.hiddenTabs?.findIndex(ht => ht.typ === 4) !== -1) {
                this.state.activeMainTab = tabId;
                this.defTab = tabId;
            }

            if (this.hhGR4E && (ebenen[i].ebene?.nachKonten??false)) {
                const tabId1 = (2*i + 4).toString();
                var bezeichnung = "Betrachtung nach " + ebenen[i].bezeichnung + " und Einnahme-/Ausgabearten";
                navItems.push(
                    <NavItem id={"kslplus-tab-" + bezeichnung.toLowerCase().replace(/ /gi, "-") + "-vermögenshaushalt-ea"} key={"mnav" + tabId1 + toString()}>
                        <NavLink active={this.state.activeMainTab === tabId1} onClick={() => this.setState({ activeMainTab: tabId1 })} tabIndex={0} onKeyDown={(e) => { if (e.keyCode === 13) this.setState({ activeMainTab: tabId1 }); }}>
                            {bezeichnung}
                        </NavLink>
                    </NavItem>
                );

                var tt = Utilities.createTTItem(this.props.settings, bezeichnung.toLowerCase().replace(/ /gi, "-") + "-vermögenshaushalt-ea");
                if (tt) {
                    navItems.push(
                        tt
                    );
                }
                contentItems.push(
                    <TabPane tabId={tabId1} key={"mtab" + tabId1 + toString()}>
                        <div className="kslplus-haushaltstab-wrapper" >
                            <GREbenenHaushalt ebenenId={ebenen[i].ebene?.ebenenId ?? ""} keineNummer={ebenen[i].ebene?.keineNummer ?? false} hh={JSON.parse(JSON.stringify(this.hhGR4E))} jahr={this.props.jahr} kunde={this.props.kunde} gemeinde={this.props.gemeinde} planstufe={this.props.planstufe} plantyp={this.props.plantyp} uhconfig={this.props.uhconfig} settings={this.props.settings} isvmhh={true} massnahmen={this.props.massnahmen} verwaltungsansicht={this.props.verwaltungsansicht} isVisible={this.props.isVisible && this.state.activeMainTab === tabId1} />
                        </div>

                    </TabPane>
                );
            }
            
        }
        

        return {navItems: navItems, contentItems: contentItems};
    }
    
    
    handleSelectHHEbene = (ebenenNum: string) => {        
        this.state.selectedGLEbene = ebenenNum;
        this.props.onSelGLChange(ebenenNum);
    }

    render() {
        if (!this.state.ready )
            return null;
        
        var ebeneItems = this.createEbeneItems(this.hhEbenen.sort((e1, e2) => (e1.ebene?.nummer ?? 0) - (e2.ebene?.nummer ?? 0)));

        var bnAText = "Betrachtung nach Aufgaben";
        var bnEAText = "Betrachtung nach Einnahme-/Ausgabearten";
        if (this.props.settings.tabTexte) {
            let text = this.props.settings.tabTexte.find(t => t.bezeichnung === "betrachtung-nach-aufgaben-vermögenshaushalt");
            if (text && text.text && text.text.length > 0)
                bnAText = text.text;

            text = this.props.settings.tabTexte.find(t => t.bezeichnung === "betrachtung-nach-einnahme-ausgabearten-vermögenshaushalt");
            if (text && text.text && text.text.length > 0)
                bnEAText = text.text;
        }


        return (
            <div className="kslplus-haushaltstab-wrapper-bottom">   
                <Nav tabs>       
                    {this.hhGL &&
                        <>
                            <NavItem id="kslplus-tab-betrachtung-nach-aufgaben-vermögenshaushalt">
                                <NavLink active={this.state.activeMainTab === "1"} onClick={() => this.setState({ activeMainTab: "1" })} tabIndex={0} onKeyDown={(e) => { if (e.keyCode === 13) this.setState({ activeMainTab: "1" }); }}>
                                    {bnAText}
                                </NavLink>
                            </NavItem>
                            {Utilities.createTTItem(this.props.settings, "betrachtung-nach-aufgaben-vermögenshaushalt")}
                        </>
                    }

                    {this.hhGR &&
                        <>
                            <NavItem id="kslplus-tab-betrachtung-nach-einnahme-ausgabearten-vermögenshaushalt">
                                <NavLink active={this.state.activeMainTab === "2"} onClick={() => this.setState({ activeMainTab: "2" })} tabIndex={0} onKeyDown={(e) => { if (e.keyCode === 13) this.setState({ activeMainTab: "2" }); }}>
                                    {bnEAText}
                                </NavLink>
                            </NavItem>
                            {Utilities.createTTItem(this.props.settings, "betrachtung-nach-einnahme-ausgabearten-vermögenshaushalt")}
                        </>
                    }
                    {ebeneItems.navItems}                    
                </Nav>     
                <TabContent activeTab={this.state.activeMainTab}>    
                    <TabPane tabId="1">   
                        {this.hhGL && 
                            <div className="kslplus-haushaltstab-wrapper" >
                                <GLHaushalt hh={this.hhGL} jahr={this.props.jahr} kunde={this.props.kunde} gemeinde={this.props.gemeinde} planstufe={this.props.planstufe} plantyp={this.props.plantyp} uhconfig={this.props.uhconfig} settings={this.props.settings} isvmhh={true} selected={this.props.selectedGL} onSelChange={this.handleSelectHHEbene} massnahmen={this.props.massnahmen} verwaltungsansicht={this.props.verwaltungsansicht} isVisible={this.props.isVisible && this.state.activeMainTab == "1"} />
                            </div>
                        }
                    </TabPane>
                    <TabPane tabId="2">   
                        {this.hhGR &&
                                <div className="kslplus-haushaltstab-wrapper">
                                    <GRHaushalt hh={this.hhGR} jahr={this.props.jahr} kunde={this.props.kunde} gemeinde={this.props.gemeinde} planstufe={this.props.planstufe} plantyp={this.props.plantyp} uhconfig={this.props.uhconfig} settings={this.props.settings} isvmhh={true} massnahmen={this.props.massnahmen} verwaltungsansicht={this.props.verwaltungsansicht} isVisible={this.props.isVisible && this.state.activeMainTab == "2"} />
                                </div>
                        }
                    </TabPane>
                    {ebeneItems.contentItems}                                      
                </TabContent>                                
            </div>             
                           
            
            
        );
    }
}